/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Mountain = [
  "svg",
  defaultAttributes,
  [["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z" }]]
];

export { Mountain as default };
//# sourceMappingURL=mountain.js.map
